import { GrowthUnifiedProfile } from './unified-profile.schema';

export type GetGrowthUnifiedProfileResponse = {
	growthUnifiedProfile_getUnifiedProfile: GrowthUnifiedProfile;
};

export type UpdateGrowthUnifiedProfileResponse = {
	growthUnifiedProfile_createUnifiedProfile: GrowthUnifiedProfile;
};

export type GetGrowthUnifiedProfileArgs = {
	accountId?: string;
	tenantId?: string;
	anonymousId?: string;
};

export enum OptionalFields {
	SITES = 'sites',
	PAID_CHANNEL_CONTEXT = 'paidChannelContext',
	USER_FOOTPRINTS = 'userFootprints',
	ONBOARDING_CONTEXT = 'onboardingContext',
	USER_PROFILE = 'userProfile',
	USER_PROFILE_JOB_FUNCTION = 'userProfileJobFunction',
}

export enum AccountProfileOptionalFields {
	USER_PROFILE = 'userProfile',
	PAID_FEATURE_USAGE = 'paidFeatureUsage',
	RECOMMENDATIONS = 'recommendations',
}

export type OptionalHeaderUseCase = {
	useCase?: string;
};

export type GrowthUnifiedProfileClientOptions = {
	// Use a slauth token when authenticating service-to-service requests
	// Note: do not include the "SLAUTH" prefix in the token
	slauthToken?: string;
};

export type GrowthUnifiedProfilePFUFilter = {
	startDate: string; // YYYY-MM-DD format
	endDate?: string; // YYYY-MM-DD format, empty value indicates current date
	featureType?: 'STATELESS' | 'STATEFUL';
	featureName?: string;
	featureSupportedEditions?: Array<
		'FREE' | 'PREMIUM' | 'STANDARD' | 'ENTERPRISE' | 'STARTER' | 'BUSINESS' | 'BUSINESS_AI'
	>;
	productKeys?: Array<
		'JIRA' | 'CONFLUENCE' | 'JIRA_SERVICE_MANAGEMENT' | 'JIRA_PRODUCT_DISCOVERY' | 'LOOM'
	>;
	tenants?: Array<{
		tenantId: string;
		tenantType: 'ORG_ID' | 'CLOUD_ID';
	}>;
	featureEngagementLevels?: Array<'INTERACTION' | 'ACTIVATION' | 'VIEW' | 'CONFIG'>;
};

export type GrowthUnifiedProfileAccountUserProfile = {
	inferredTimezone?: string; // IANA time zone identifier (e.g., "America/New_York")
};

export type GrowthUnifiedProfilePFUResult = {
	featureType: 'STATELESS' | 'STATEFUL';
	featureName: string;
	featureSupportedEdition: Array<
		'FREE' | 'PREMIUM' | 'STANDARD' | 'ENTERPRISE' | 'STARTER' | 'BUSINESS' | 'BUSINESS_AI'
	>;
	usageSummary: {
		tenants: Array<{
			tenantId: string;
			tenantType: 'ORG_ID' | 'CLOUD_ID';
		}>;
		products: Array<
			'JIRA' | 'CONFLUENCE' | 'JIRA_SERVICE_MANAGEMENT' | 'JIRA_PRODUCT_DISCOVERY' | 'LOOM'
		>;
		entitlementIds?: string[];
		featureEngagementLevel: Array<'INTERACTION' | 'ACTIVATION' | 'VIEW' | 'CONFIG'>;
		usageCount: number;
	};
};

export type NBPUserRecommendationProduct = {
	key: string; // e.g., 'v3', 'v2'
	values: string[]; // e.g., ["jira service management", "trello", ...]
};

export type UserRecommendations = {
	nbp?: NBPUserRecommendationProduct[];
};

export type GrowthUnifiedProfileAccountProfile = {
	userProfile?: GrowthUnifiedProfileAccountUserProfile;
	paidFeatureUsage?: GrowthUnifiedProfilePFUResult[];
	recommendations?: UserRecommendations;
};

export type GetGrowthUnifiedProfileAccountProfileResponse = {
	growthUnifiedProfile_getAccountProfile: GrowthUnifiedProfileAccountProfile;
};

export type GetGrowthUnifiedProfileAccountProfileArgs = {
	accountId: string;
	// pfuFilter is only used when ACCOUNT_PAID_FEATURE_USAGE is in optionalFields
	pfuFilter?: GrowthUnifiedProfilePFUFilter;
};
